import Block from './Block'
import gsap from 'gsap';

export default class CardTraining extends Block {
  onEnterCompleted() {
    this.resize()
    this.arrows()
  }

  getElems() {
    super.getElems()
    this.cards = []
    this.$cards = this.el.querySelectorAll('.card-training')

    for (let i = 0; i < this.$cards.length; i++) {
      this.cards.push({
        el: this.$cards[i],
        content: this.$cards[i].querySelector('.card-training__desc')
      })
    }
  }

  arrows() {
    this.$cards.forEach( (card) => {
      const arrow = card.querySelector(".card-training__arrow");

      if (arrow) {
        // Configuration de base pour les animations
        const btnConfig = {duration: 0.45, ease: "power2.out"};

        // Création des fonctions quickTo avec des configurations distinctes
        const moveBtnPosition = {
          top: gsap.quickTo(arrow, "top", btnConfig),
          left: gsap.quickTo(arrow, "left", btnConfig)
        };

        // Animations standards pour les autres propriétés
        card.addEventListener("mouseenter", (e) => {
          const blockOffset = card.getBoundingClientRect();

          // Animation de l'apparition
          gsap.to(arrow, {
            opacity: 1,
            duration: 0.3
          });

          // Positionnement initial
          moveBtnPosition.top(e.clientY - blockOffset.top);
          moveBtnPosition.left(e.clientX - blockOffset.left);
        });

        card.addEventListener("mousemove", (e) => {
          const blockOffset = card.getBoundingClientRect();
          moveBtnPosition.top(e.clientY - blockOffset.top);
          moveBtnPosition.left(e.clientX - blockOffset.left);
        });

        card.addEventListener("mouseleave", () => {
          gsap.to(arrow, {
            opacity: 0,
            duration: 0.3
          });
        });
      }
    });
  }

  resize() {
    super.resize()

    for (let i = 0; i < this.cards.length; i++) this.cards[i].content && this.cards[i].el.style.setProperty('--height', this.cards[i].content.offsetHeight + 'px')
  }
}
